/**
 * Created by sidchik on 16.10.14.
 */
//function listenForShare() {
//    if (window.addEventListener) {
//        window.addEventListener('message', onShare, false);
//    } else {
//        window.attachEvent('onmessage', onShare);
//    }
//}
//var successCallback = null;
//var errorCallback = null;
//var firstIgnored = false;
//function onShare(e) {
//    if (e.origin.indexOf('odnoklassniki')>0) {
//        console.log(e);
//        var args = e.data.split("$");
//        if (args[0] == "ok_shared") {
//              firstIgnored = false;
//              successCallback();
//            $(".shareButton").remove();
//        } else {
//            if (!firstIgnored){firstIgnored=true; return false;}
//            $(".shareButton").remove();
//            errorCallback();
//        }
//    }
//}
//listenForShare();
//function genOkHTML(data) {
//  return '<div id="ok_shareWidget"></div>\n' +
//          '<script>\n' +
//          '!function (d, id, did, st) {\n' +
//          '  var js = d.createElement("script");\n' +
//          '  js.src = "http://connect.ok.ru/connect.js";\n' +
//          '  js.onload = js.onreadystatechange = function () {\n' +
//          '  if (!this.readyState || this.readyState == "loaded" || this.readyState == "complete") {\n' +
//          '    if (!this.executed) {\n' +
//          '      this.executed = true;\n' +
//          '      setTimeout(function () {\n' +
//          '        OK.CONNECT.insertShareWidget(id,did,st);\n' +
//          '      }, 0);\n' +
//          '    }\n' +
//          '  }};\n' +
//          '  d.documentElement.appendChild(js);\n' +
//          '}(document,"ok_shareWidget","'+data+'","{width:310,height:50,st:\'straight\',sz:45,ck:2}");\n' +
//          '</script>\n';
//}
//
//function setSocialButtonOK($modal, postData)
//{
//  firstIgnored=false;
//  successCallback = postData.success;
//  errorCallback = postData.error;
//
//
//  var isShare = false;
//  var confirm = $modal.find('.confirm');
//  if (confirm.length == 0) {
//    confirm = $modal.find('.btn-block');
//    isShare = true;
//  }
//  if (!confirm.parent().hasClass('boxer')) {
//    var confirmClone = confirm.clone();
//    var box = $("<div/>").css({
//      position: 'relative',
//      display: 'inline-block'
//    }).addClass('boxer');
//    if (isShare) {
//      box.css('width', '100%');
//    }
//    box.append(confirmClone);
//    confirm.replaceWith(box);
//  }else {
//    box = confirm.parent();
//  }
//
//  var shareButton = $("<div/>").addClass('shareButton');
//  shareButton.css({
//    left: 0,
//    top: '25px',
//    width: '100%',
//    height: '45px'
//  });
//
//  if (isShare){
//    shareButton.css('top', '0');
//  }
//
//  box.append(shareButton);
//
//  shareButton.html(genOkHTML(postData.url));
//
//}


//
//$(document).ready(function(){
//  $("#finalShare").trigger('click');
//});


function setSocialButtonOK($modal, postData)
{

}

function socialPostOK(postData) {
  Share.ok(postData);
  //Share.openPopup('ok', postData);
  //postData.success();
}
